import { HttpInterceptorFn } from '@angular/common/http';
import { HTTP_TIMEOUT } from '@movilidad/app-core';
import { environment } from 'src/environments/environment';

/**
 * Las compras con tarjeta esperan la respuesta de la pasarela: el API le da a PayCode hasta 6 s de
 * login + 80 s de cobro (`services.paycode.*`) para no cortar un cargo que el banco sí aprobó. Con
 * los 25 s por omisión de `timeoutInterceptor` el app se rendía antes: el usuario veía un error
 * mientras el API terminaba la compra (el 13-oct-2026, tres compras de ~53 s), y al reintentar le
 * contestaban "Ya tienes una compra en proceso". Debe ir antes de `timeoutInterceptor`.
 */
export const PURCHASE_TIMEOUT_MS = 100_000;

const PURCHASE_ENDPOINTS = ['bustickets', 'pay_balance', 'suscription-radial-payments', 'busticket_packages'];

export const purchaseTimeoutInterceptor: HttpInterceptorFn = (request, next) => {
  if (request.method !== 'POST' || !request.url.startsWith(environment.apiBaseUrl)) {
    return next(request);
  }

  const path = request.url.slice(environment.apiBaseUrl.length).split('?')[0];
  if (!PURCHASE_ENDPOINTS.includes(path)) {
    return next(request);
  }

  return next(request.clone({ context: request.context.set(HTTP_TIMEOUT, PURCHASE_TIMEOUT_MS) }));
};
